<template>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CheckoutSuccess',
    data() {
      return {

      };
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getHistoryPage() {
        return this.$store.state.historyPage
      }
    },
    methods: {

    },
    created() {
      let self = this;
      // Component accessed when going on route: base_url/token/{token}
      // We are taking the token and logging users in, and after that, redirecting to homepage
      if (this.$route.params.token) {
        if (this.$route.params.token == 'invalid') {
          setTimeout(function() {
            self.$router.push({name: 'login', params: {error: true}})
          }, 300)
        } else {
          localStorage.setItem('token', this.$route.params.token);
          piincHttp.defaults.headers.common['Authorization'] = this.$route.params.token;
          setTimeout(function() {
            piincHttp.get('users/me', {
              headers: {
                'Authorization': 'Bearer ' + self.$route.params.token
              }
            }).then(function(response) {
              let selectedClient = {}

              selectedClient = response.data.clients[0]

              if (self.$route.params.client) {
                window.location.href = '/client/' + self.$route.params.client + '?tabindex=1&modal=success';
              } else {
                window.location.href = '/client/' + selectedClient.slug + '?tabindex=1&modal=success';
              }

            }, function() {

            });

          }, 500)
        }
      }
    }
  }

</script>
